import { toast } from "@redotech/redo-web/alert";
import { createQueryClient } from "@redotech/redo-web/rpc-query/react-query-config";
import { MutationCache, QueryCache } from "@tanstack/react-query";
import { Cause, Runtime } from "effect";

export function extractUserMessage(error: unknown): string {
  if (Runtime.isFiberFailure(error)) {
    const cause = error[Runtime.FiberFailureCauseId];
    for (const defect of Cause.defects(cause)) {
      if (defect instanceof Error && defect.message) {
        return defect.message;
      }
    }
    // FiberFailure with no usable defect message — don't fall through to bare
    // Error check since FiberFailure extends Error and has its own .message.
    return "An unexpected error occurred. Please try again.";
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return "An unexpected error occurred. Please try again.";
}

export const merchantQueryClient = createQueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.showErrorToast) {
        toast(extractUserMessage(error), { variant: "error" });
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.options.meta?.showErrorToast) {
        toast(extractUserMessage(error), { variant: "error" });
      }
    },
  }),
});
